import { render, staticRenderFns } from "./formSupplierApply.vue?vue&type=template&id=084b6bce&"
import script from "./formSupplierApply.vue?vue&type=script&lang=js&"
export * from "./formSupplierApply.vue?vue&type=script&lang=js&"
import style0 from "./formSupplierApply.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports